export default __webpack_public_path__ + "static/media/ic_stickers.b271b512.svg";